var _style, _path, _path2, _circle, _line, _path3, _path4, _path5, _circle2, _path6, _path7, _rect, _line2, _line3, _line4, _line5, _circle3, _g, _line6, _path8, _path9, _polyline, _line7, _path0, _path1, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 324 216",
    style: {
      enableBackground: "new 0 0 324 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1E6EA;}\n\t.st1{fill:#F9F9F9;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#3C4650;stroke-width:1.25;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFAA96;stroke:#212C38;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#FFFFFF;stroke:#3C4650;stroke-width:1.45;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#748699;stroke-width:0.95;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:none;stroke:#212C38;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#FF4338;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#FF4338;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#FF4338;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account_backup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.6,143.2c0,3.4,2.7,6.1,6.1,6.1l0,0h170.6c3.4,0,6.1-2.7,6.1-6.1l0,0V43c0-3.4-2.7-6.1-6.1-6.1l0,0H124.7 c-3.4,0-6.1,2.7-6.1,6.1 M291.5,136.6c0,2.9-2.3,5.2-5.2,5.2H134.9c-2.9,0-5.2-2.3-5.2-5.2V52.8c0-2.9,2.3-5.2,5.2-5.2h151.5 c2.9,0,5.2,2.3,5.2,5.2l0,0L291.5,136.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310,169.3c-2-2.2-4.3-5-5.5-6.5c-2.6-3.1-4.4-4.5-8.7-4.5H125.2c-4.3,0-6.2,1.3-8.7,4.5 c-1.2,1.4-3.5,4.2-5.5,6.5s-1.8,4.8,4.4,4.8h190.1C311.8,174.1,311.9,171.5,310,169.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.4,
    cy: 150.7,
    r: 4.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 44,
    y1: 46.6,
    x2: 52.4,
    y2: 46.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.6,75.4V44.5c0-3.4,2.7-6.1,6.1-6.1h170.6c3.4,0,6.1,2.7,6.1,6.1l0,0V107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.7,131.4v13.3c0,3.4,2.7,6.1,6.1,6.1l0,0h88.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320,173.8c-2.7-3-5.8-6.9-7.5-8.8c-3.5-4.3-6.1-6.1-11.9-6.1H120.9c-5.8,0-8.4,1.8-11.9,6.1 c-1.7,1.9-4.8,5.8-7.5,8.8s-2.5,6.5,6,6.5H314C322.5,180.3,322.7,176.8,320,173.8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 49.3,
    cy: 99.5,
    r: 20.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40,101.7h1.1c1.5,0,1.5-0.9,1.5-1.9v-2.6h-4v2.6C38.5,100.8,38.5,101.7,40,101.7z M39.9,98.6h1.3v1.7h-1.3 V98.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.7,96.4h7.7v-1.5H36.2v4.9c0,2.8,1.2,4.2,3.7,4.2h1.4c2.4,0,3.6-1.4,3.6-4.3v-1h10.7v2.3h-1.4v1.5H57v-5.2 H43.4v2.5c0,2.3-0.9,2.8-2.2,2.8h-1.3c-1.4,0-2.2-0.4-2.2-2.7v-3.5H54.7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 54.5,
    className: "st6",
    width: 69.6,
    height: 88.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 105,
    x2: 80.7,
    y2: 105
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 79.4,
    x2: 79,
    y2: 79.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.3,
    y1: 88,
    x2: 79.7,
    y2: 88
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 88.1,
    y1: 99.1,
    x2: 222.7,
    y2: 99.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 208.5,
    cy: 98.6,
    r: 20.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217.1,101.6 219.9,101.6 219.9,100.1 218.6,100.1 218.6,97.8 221.6,97.8 221.6,96.3 217.1,96.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199.2,100.8h1.1c1.5,0,1.5-0.9,1.5-1.9v-2.6h-4v2.6C197.7,99.9,197.7,100.8,199.2,100.8z M199.1,97.7h1.3v1.7 h-1.3V97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M213.9,95.5h7.7V94h-26.2v4.9c0,2.8,1.2,4.2,3.7,4.2h1.4c2.4,0,3.6-1.4,3.6-4.3v-1h10.7v2.3h-1.4v1.5h2.8v-5.2 h-13.6v2.5c0,2.3-0.9,2.8-2.2,2.8h-1.3c-1.4,0-2.2-0.4-2.2-2.7v-3.5L213.9,95.5"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 28,
    y1: 97.2,
    x2: 77,
    y2: 97.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M28.6,64.4v1.2c0,0.1,0,0.8-0.7,0.8h-0.8c-0.6,0-0.6-0.6-0.6-0.8v-1.2H28.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.1,61.5h-22v4.6c0,0.8,0.1,3.1,2.4,3.1h1.6c2.7,0,2.7-2.7,2.7-3.1v-1.7h8.8v3.3h-2.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "46.1,64.4 42.6,64.4 42.6,67.7 44.9,67.7 "
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 71.3,
    y1: 130.7,
    x2: 79,
    y2: 130.7
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M78.3,130.8v3c0,1.2-0.9,2.1-2.1,2.1h-2c-1.2,0-2.1-0.9-2.1-2.1v-3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M73.2,130.5v-2.3c0-0.7,0.5-1.3,1.2-1.3h1.4c0.7,0,1.2,0.6,1.2,1.3v2.3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.6,
    y: 132.1,
    className: "st11",
    width: 1.2,
    height: 0.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "75.7,134.4 74.6,134.4 75,132.8 75.3,132.8 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreAccount);
export default __webpack_public_path__ + "static/media/restore-account.1035f51f835d980679ce53e8533b1494.svg";
export { ForwardRef as ReactComponent };